export const EXPIRED_LINK_MESSAGE =
  'Invalid or expired access link. Please request a new link.';
